import type {FC, PropsWithChildren} from 'react';
import clsx from 'clsx';

import type {ContainerSpacing} from '@/modules/foundation/components/container';
import {Container} from '@/modules/foundation/components/container';
import type {ImageWeb} from '@/modules/foundation/components/image/types';
import type {KeyedArray} from '@/modules/foundation/shared/types';

import DocumentCard from './DocumentCard';

export interface DocumentInCard {
	href: string;
	title: string;
	image?: ImageWeb;
	imageAltText?: string;
}

interface Props extends PropsWithChildren {
	heading?: string;
	spacingTop?: ContainerSpacing;
	spacingBottom?: ContainerSpacing;
	documents?: KeyedArray<DocumentInCard>;
}

const DocumentCardGrid: FC<Props> = ({heading, spacingBottom, spacingTop, documents}) => {
	return (
		<Container spacingBottom={spacingBottom} spacingTop={spacingTop} width="text">
			{heading && (
				<h2 className={clsx('text-xl', 'text-dypgronn-industri', 'mb-2')}>{heading}</h2>
			)}

			<ul className={clsx('grid', 'gap-1', 'grid-cols-1')}>
				{documents?.map((link) => (
					<li key={link._key}>
						<DocumentCard title={link.title} href={link.href} />
					</li>
				))}
			</ul>
		</Container>
	);
};

export default DocumentCardGrid;
